import React from 'react';
import { useSharedPluginState, sharedPluginStateHookMigratorFactory } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import Toolbar from './Toolbar';
import { ToolbarType } from './Toolbar/types';
var useSharedState = sharedPluginStateHookMigratorFactory(function (api) {
  var isInitialised = useSharedPluginStateSelector(api, 'textFormatting.isInitialised');
  var formattingIsPresent = useSharedPluginStateSelector(api, 'textFormatting.formattingIsPresent');
  var emActive = useSharedPluginStateSelector(api, 'textFormatting.emActive');
  var emDisabled = useSharedPluginStateSelector(api, 'textFormatting.emDisabled');
  var emHidden = useSharedPluginStateSelector(api, 'textFormatting.emHidden');
  var codeActive = useSharedPluginStateSelector(api, 'textFormatting.codeActive');
  var codeDisabled = useSharedPluginStateSelector(api, 'textFormatting.codeDisabled');
  var codeHidden = useSharedPluginStateSelector(api, 'textFormatting.codeHidden');
  var underlineActive = useSharedPluginStateSelector(api, 'textFormatting.underlineActive');
  var underlineDisabled = useSharedPluginStateSelector(api, 'textFormatting.underlineDisabled');
  var underlineHidden = useSharedPluginStateSelector(api, 'textFormatting.underlineHidden');
  var strikeActive = useSharedPluginStateSelector(api, 'textFormatting.strikeActive');
  var strikeDisabled = useSharedPluginStateSelector(api, 'textFormatting.strikeDisabled');
  var strikeHidden = useSharedPluginStateSelector(api, 'textFormatting.strikeHidden');
  var strongActive = useSharedPluginStateSelector(api, 'textFormatting.strongActive');
  var strongDisabled = useSharedPluginStateSelector(api, 'textFormatting.strongDisabled');
  var strongHidden = useSharedPluginStateSelector(api, 'textFormatting.strongHidden');
  var superscriptActive = useSharedPluginStateSelector(api, 'textFormatting.superscriptActive');
  var superscriptDisabled = useSharedPluginStateSelector(api, 'textFormatting.superscriptDisabled');
  var superscriptHidden = useSharedPluginStateSelector(api, 'textFormatting.superscriptHidden');
  var subscriptActive = useSharedPluginStateSelector(api, 'textFormatting.subscriptActive');
  var subscriptDisabled = useSharedPluginStateSelector(api, 'textFormatting.subscriptDisabled');
  var subscriptHidden = useSharedPluginStateSelector(api, 'textFormatting.subscriptHidden');
  return {
    isInitialised: Boolean(isInitialised),
    formattingIsPresent: formattingIsPresent,
    emActive: emActive,
    emDisabled: emDisabled,
    emHidden: emHidden,
    codeActive: codeActive,
    codeDisabled: codeDisabled,
    codeHidden: codeHidden,
    underlineActive: underlineActive,
    underlineDisabled: underlineDisabled,
    underlineHidden: underlineHidden,
    strikeActive: strikeActive,
    strikeDisabled: strikeDisabled,
    strikeHidden: strikeHidden,
    strongActive: strongActive,
    strongDisabled: strongDisabled,
    strongHidden: strongHidden,
    superscriptActive: superscriptActive,
    superscriptDisabled: superscriptDisabled,
    superscriptHidden: superscriptHidden,
    subscriptActive: subscriptActive,
    subscriptDisabled: subscriptDisabled,
    subscriptHidden: subscriptHidden
  };
}, function (api) {
  var _useSharedPluginState = useSharedPluginState(api, ['textFormatting']),
    textFormattingState = _useSharedPluginState.textFormattingState;
  return {
    isInitialised: Boolean(textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.isInitialised),
    formattingIsPresent: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.formattingIsPresent,
    emActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.emActive,
    emDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.emDisabled,
    emHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.emHidden,
    codeActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.codeActive,
    codeDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.codeDisabled,
    codeHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.codeHidden,
    underlineActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.underlineActive,
    underlineDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.underlineDisabled,
    underlineHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.underlineHidden,
    strikeActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strikeActive,
    strikeDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strikeDisabled,
    strikeHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strikeHidden,
    strongActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strongActive,
    strongDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strongDisabled,
    strongHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.strongHidden,
    superscriptActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.superscriptActive,
    superscriptDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.superscriptDisabled,
    superscriptHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.superscriptHidden,
    subscriptActive: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.subscriptActive,
    subscriptDisabled: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.subscriptDisabled,
    subscriptHidden: textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.subscriptHidden
  };
});
export function PrimaryToolbarComponent(_ref) {
  var _api$analytics;
  var api = _ref.api,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    toolbarSize = _ref.toolbarSize,
    editorView = _ref.editorView,
    disabled = _ref.disabled,
    isReducedSpacing = _ref.isReducedSpacing,
    shouldUseResponsiveToolbar = _ref.shouldUseResponsiveToolbar;
  var textFormattingState = useSharedState(api);
  return /*#__PURE__*/React.createElement(Toolbar, {
    textFormattingState: textFormattingState,
    popupsMountPoint: popupsMountPoint,
    popupsScrollableElement: popupsScrollableElement,
    toolbarSize: toolbarSize,
    isReducedSpacing: isReducedSpacing,
    editorView: editorView,
    isToolbarDisabled: disabled,
    shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
    editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
    api: api,
    toolbarType: ToolbarType.PRIMARY
  });
}